<script>
import {PrismEditor} from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import {highlight, languages} from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-css";
import "prismjs/components/prism-markup";
import "prismjs/themes/prism-tomorrow.css";
import cssParser from 'css';
import defaultCSS from "@/data/examples/whitelabel.css";

export default {
  components: {
    PrismEditor,
  },
  data: () => ({
    originalCSS: null,
    cssEdited: false,
  }),
  computed: {
    css: {
      get() {
        if (this.$store.state.whitelabel.css.custom === '') {
          return defaultCSS;
        }
        return this.$store.state.whitelabel.css.custom;
      },
      set(value) {
        this.$store.state.whitelabel.css.custom = value;
      }
    },
    isModified() {
      return JSON.stringify(this.css) !== JSON.stringify(this.originalCSS);
    },
    areRequiredFieldsEmpty() {
      return !this.css?.length;
    },
    isValidCSS() {
      try {
        cssParser.parse(this.css);
        return true;
      } catch (e) {
        return false;
      }
    },
    isSaveDisabled() {
      return this.areRequiredFieldsEmpty || !this.isValidCSS || !this.$store.getters.urls.subdomain;
    },
  },
  created() {
    this.originalCSS = this?.css;
  },
  methods: {
    cssHighlighter(code) {
      return highlight(code, languages.css);
    },
    resetCSS() {
      this.$store.dispatch('resetCSS');
    },
    save() {
      if (!this.isSaveDisabled) {
        this.$store.dispatch('putCSS', {custom: this.css}).then(() => {
          this.$store.dispatch('getCSS')
          this.originalCSS = this.css;
        });
      }
    }
  }
}
</script>

<template>
  <v-container fluid class="pt-0">
    <v-row class="pt-0">
      <v-col class="pt-0">
        <h3 class="float-left">{{ $t('component.whitelabel.custom.css.heading') }}</h3>
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn id="reset-default-css" class="float-right" icon color="primary" v-on="on" @click="resetCSS">
              <v-icon>mdi-autorenew</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('component.whitelabel.custom.css.reset.button.tooltip') }}</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <!--ERROR BANNER-->
    <v-row v-if="!isValidCSS" id="invalid-css-hint">
      <v-col>
        <v-fade-transition>
          <v-banner
            v-if="!isValidCSS"
            color="red"
            style="color: white"
            icon-color="white"
            icon="mdi-alert">
            {{ $t('component.whitelabel.custom.css.validation.css.invalid') }}
          </v-banner>
        </v-fade-transition>
      </v-col>
    </v-row>
    <!-- CSS EDITOR-->
    <v-row>
      <v-col>
        <prism-editor
          id="whitelabel-custom-css"
          v-model="css"
          :disabled="!$store.getters.urls.subdomain"
          class="css-editor"
          :highlight="cssHighlighter"
          line-numbers>
        </prism-editor>
      </v-col>
    </v-row>
    <!-- SAVE BUTTON -->
    <v-row>
      <v-col>
        <v-fade-transition>
          <v-btn
            v-if="isModified"
            id="save-custom-css-button"
            color="primary"
            block
            :disabled="isSaveDisabled"
            @click="save">
            <v-icon class="pe-3">mdi-check</v-icon>
            {{ $t('button.save') }}
          </v-btn>
        </v-fade-transition>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
.css-editor {
  background: #2d2d2d;
  color: #ccc;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

.prism-editor__textarea:focus {
  outline: none;
}
</style>
